import React from 'react';
import useBundleTranslation from 'i18n';
import { Box, Stack } from '@mui/material';
import { YNValues } from 'tools/types';
import { FormDataAPIType } from 'components/common/form';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';
import EditPanelCheckBox from 'app/editor/report/content-editor/block-edit-panel/edit-panel-components/EditPanelCheckBox';
import EditPanelLabel from 'app/editor/report/content-editor/block-edit-panel/edit-panel-components/EditPanelLabel';

export default function KpiVarianceSection({ elementProps }: { elementProps: FormDataAPIType }) {
    const { t } = useBundleTranslation(['components/report-content']);
    const includeKpiVariance: YNValues = elementProps.form.hookFormWatch('includeKpiVariance') ?? 'N';

    return (
        <Stack spacing={2}>
            <EditPanelCheckBox
                elementProps={elementProps}
                name={'includeKpiVariance'}
                label={t('kpi_chart.include_kpi_variance')}
            />
            <Stack spacing={2} className={includeKpiVariance == 'Y' ? '' : 'd-none'}>
                <Stack direction={'row'} spacing={1}>
                    <Box>
                        <EditPanelLabel>{t('kpi_chart.compare_value_period')}</EditPanelLabel>
                        <TemplateFormComponent
                            elementProps={elementProps}
                            component={'FormText'}
                            name={'varianceCompareValuePeriod'}
                            label={''}
                        />
                    </Box>
                    <Box sx={{ width: '100px' }}>
                        <EditPanelLabel>{t('kpi_chart.compare_value_unit')}</EditPanelLabel>
                        <TemplateFormComponent
                            elementProps={elementProps}
                            component={'FormSelect'}
                            name={'varianceCompareValueUnit'}
                            componentValues={[
                                { label: 'day', value: 'day' },
                                { label: 'week', value: 'week' },
                                { label: 'month', value: 'month' },
                                { label: 'year', value: 'year' },
                            ]}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', pl: '4px', pt: '18px' }} alignItems={'center'}>
                        {t('kpi_chart.ago')}
                    </Box>
                </Stack>
                <Box>
                    <EditPanelLabel>{t('kpi_chart.show_variance_as')}</EditPanelLabel>
                    <TemplateFormComponent
                        elementProps={elementProps}
                        component={'FormToggleButtonGroup'}
                        name={'showVarianceAs'}
                        props={{ width: '100%' }}
                        componentValues={[
                            { label: t('kpi_chart.percentage_value'), value: 'percentage' },
                            { label: t('kpi_chart.absolute_value'), value: 'absolute' },
                        ]}
                    />
                </Box>
            </Stack>
        </Stack>
    );
}
